import script from "./RoomHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./RoomHistoryModal.vue?vue&type=style&index=0&id=56c9eacf&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c9eacf"]])

export default __exports__